import { StarIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Star = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <StarIcon {...rest} size={Sizes[size]} color={fill} />;
};

Star.displayName = 'Star';
